var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldWalletMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5H7c-2.76 0-5-2.24-5-5v-7c0-2.72 1.64-4.62 4.19-4.94.26-.04.53-.06.81-.06h9c.26 0 .51.01.75.05 2.39.28 4.01 1.95 4.22 4.37a.49.49 0 0 1-.5.53h-1.55c-.96 0-1.85.37-2.49 1.03-.76.74-1.14 1.78-1.05 2.82.16 1.82 1.76 3.25 3.66 3.25h1.43c.29 0 .53.24.5.53-.24 2.67-2.17 4.42-4.97 4.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13.03c0 .55-.44 1-1 1.02h-1.96c-1.08 0-2.07-.79-2.16-1.87-.06-.63.18-1.22.6-1.63.37-.38.88-.6 1.44-.6H21c.56.02 1 .47 1 1.02v2.06z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldWalletMoney);
export default __webpack_public_path__ + "static/media/vuesax-bold-wallet-money.f1c5bb8cac2235e157e501ae3ad35030.svg";
export { ForwardRef as ReactComponent };